<template>
  <div>
    <div id="schowek-box" v-if="attributes_active && Object.keys(attributes_active).length > 0">
      <button style="padding: 4px 20px;
  margin-top: -2px;
  border: medium;
  background: white;
  cursor: pointer;
  color: red;" @click="clearBin()">
        <md-icon
          class="fa fa-times"
          style="color:#ff9a9a;font-weight: normal; font-size: 15px !important;"
        ></md-icon>
      {{ $t("clear") }}</button>
      <ul v-if="attributes_active">
        <template v-for="(attr, index) in attributes_active">
          <!-- {{ attr }} -->
            <template v-if="attr.type">
              <li v-for="(val, inVal) in attr.values.slice(0,1)" :key="index+'-'+inVal">
                <a @click="delete_list_attributes(index, val, attr)">
                  <span style="float: left; margin-right: 0px; cursor: pointer;">
                    <md-icon
                      class="fa fa-times"
                      style="color:#ff9a9a;font-weight: normal; font-size: 15px !important;"
                    ></md-icon>
                  </span>
                  <span><i v-if="attr.translationParent">{{attr.translationParent}}</i> || <i v-if="attr.values">min {{ attr.values[0] }} max {{ attr.values[1] }}</i></span>
                </a>
                </li>
            </template>
            <template v-else>
              <li v-for="(val, inVal) in attr.values" :key="index+'-'+inVal">
                <a @click="delete_list_attributes(index, val, attr)">
                  <span style="float: left; margin-right: 0px; cursor: pointer;">
                    <md-icon
                      class="fa fa-times"
                      style="color:#ff9a9a;font-weight: normal; font-size: 15px !important;"
                    ></md-icon>
                  </span>

                  <template v-if="list_attributes[index]['subgroup']">
                    <span v-if="list_attributes[index]['translation']"> {{list_attributes[index]['translation']}} || {{ findTransaltion(list_attributes[index]['subgroup'], val) }}</span>
                  </template>
                  <template v-else>
                    <span><i v-if="attr.translationParent">{{attr.translationParent}}</i> || <i v-if="attr.translationChild && attr.translationChild[inVal]">{{attr.translationChild[inVal]}}</i></span>
                    <!-- {{ attr.values }} -->
                    <!-- <span v-if="list_attributes[index]['translation']"> {{list_attributes[index]['translation']}} || {{ getTranslationValue(list_attributes[index].parametrs, val) }}</span> -->
                  </template>

                </a>
              </li>
            </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Schowek",
  data() {
    return {};
  },
  //-------------------------------------------------------------
  computed: {
    ...mapGetters('products',["dataValue", "attributes_active", "list_attributes"])
  },
  methods: {
    deleteBin(elem) {
      for (let i = 0; i < this.active_group.length; i++) {
        if (this.active_group[i].tab == elem.tab) {
          // console.log("asdsa");
          this.$store.commit("DEL_ACTIVE_GROUP", {
            tab: elem.tab,
            id: elem.id,
            value: elem.value,
            template: elem.template
          });
        }
      }
    },
    delete_list_attributes(item, elem, attr) {
      console.log('item', item)
      console.log('elem', elem)
      console.log('attr', attr)

      var deletedItem = []
      deletedItem[item] = []
      // deletedItem[item]['values'] = [elem]

      var data = []
      data['values'] = JSON.parse(JSON.stringify(attr.values))
      data['translationParent'] = JSON.parse(JSON.stringify(attr.translationParent))
      data['translationChild'] = (attr.translationChild) ? JSON.parse(JSON.stringify(attr.translationChild)) : null
      // console.log(data)
      for(var i in data['values']){
        if(data['values'][i]==elem){
            data['values'].splice(i,1);
            break;
        }
      }
      deletedItem[item] = data

      if (attr['type'] && attr['type'] == 'slider') {
        this.$store.dispatch('products/delete_data_values', deletedItem)
      } else {
        // 2025-02-21
        // this.$store.dispatch('products/set_data_values', deletedItem)
        this.$store.dispatch('products/delete_data_values', deletedItem)
      }
    },
    clearBin () {
      // attributes_active
      this.$store.commit("products/SET_ATTRIBUTES_ACTIVE", [])
      this.$store.commit("products/SET_DATA_VALUE", [])
      this.$store.dispatch("products/load_attributes", []);

    },
    findTransaltion (arr, key) {
      var str = 'xxx'
      Object.values(arr).forEach(element => {
        if (element.parametrs) {
          Object.values(element.parametrs).forEach(item => {
            if (item.value == key) {
              // console.log(item.translation)
              str = item.translation
            }
          })
        }
      })
      return str
    },
    getTranslationValue (attr, slug) {
      var title = ''
      var arr = JSON.parse(JSON.stringify(attr))
      Object.values(arr).forEach(element => {
        // console.log(element)
        if (element.value == slug) {
          if (element.translation) {
            title = element.translation
          } else {
            title = element.value
          }
        }
      });
      return title
    }
  }
};
</script>

<style scoped>
.md-icon {
  height: 18px;
}
#schowek-box {
padding: 2px;
  border: 1px solid #999;
  margin: 10px;
  background: #f4f4f4;
  width: 392px;
  float: none;
}
#schowek-box ul {
  text-align: left;
  list-style: none;
  padding-left: 0px;
  margin-top: 2px;
  margin-bottom: 2px;
}
#schowek-box a {
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  display: block;
  padding: 2px;
}
#schowek-box a:hover {
  background: #e3e3e3;
}
#schowek-box a span:first i {
  font-size: 14px !important;
  color: #ff9a9a;
}
.md-theme-default a:not(.md-button) {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/Schowek.vue